module.exports = __webpack_public_path__ + "media/images/favicon-4a92872a.ico";